<template>
  <div>
	  <!-- {{languageMode}} -->
	  <!--Edit by ankit-->
		<!-- <div class="divider mgt-8" v-if="boardList && boardList.length>0"> </div> -->
		<div class="pdt-4 pdb-4" v-if="boardList && boardList.length>0">
			<div class="mdc-list-item" :class="routeName[0]=='board'?'mdc-list-item--activated activeClass':''" v-if="boardList.length>0">
				<span class="mdc-list-item__ripple"></span>
				<router-link tabindex="0"  class="parent_link" :to="'/board/'+boardList[0].identifier+'?boardName='+encodeURI(boardList[0].name.replace('&', '-'))+'&categoryName='+encodeURI(boardList[0].boardCategory.name)" >
					<i class="material-icons mdc-list-item__graphic mgl-16 mgr-36 font-22" aria-hidden="true">forum</i>
					<span class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA">{{ $t("2067") }}</span>
				</router-link>
				<button class="material-icons mgl-auto mgr-16 t-color-bodyGrayA content-trigger pdx-0" aria-hidden="true" tabindex="0" @click="autoCloseToggleBoard($event)" >
					{{activeRouteName=='boardlist'?'keyboard_arrow_up':'keyboard_arrow_down'}}
				</button>
			</div>
			<div v-if="boardList.length>0" class="navDrawerSubmenu" :class="routeName[0] == 'board' ? '' : 'd-none'">
				<!-- <div class="pdt-4 pdb-4" v-for="board in boardList" :key="board.id" :tabindex="board.identifier==activeRouteNameSocial?'0':'-1'" @click="closeDrawer"> -->
				<div class="pdt-4 pdb-4 mgl-8 mgr-8 b-radius4" v-for="board in boardList" :key="board.id" >
						<router-link tabindex="0" v-if="board.boardAuth===true"  @click="closeDrawer" @keypress="closeDrawer"
						:class="routeQuery.boardName == board.name.replace('&', '-') ? 'router-link-exact-active' :''"
						:to="'/board/'+board.identifier+'?boardName='+encodeURI(board.name.replace('&', '-'))+'&categoryName='+encodeURI(board.boardCategory.name)">
						<div class="mdc-list-item pdl-50">
							<span class="mdc-list-item__ripple"></span>
							<span	class="mdc-list-item__text t-body2 font-m t-color-bodyGrayA t-color-bodyGrayA pdl-24">
								{{ board.name | charLimit}}
								</span>
					</div>
					</router-link>
					<!-- <div class="divider mgt-8 mgb-8" v-if="board.boardAuth===true"></div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 네비게이션 드로워 언어 목록 컴포넌트(navigation drawer language list Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import i18nApi from '@/api/i18nApi.js'
import boardApi from '@/api/boardApi.js'
import { setUserLanguage } from '@/translations/i18nSetup'
import {mapState, mapMutations} from 'vuex'

export default {
	props:['activeRouteName','boardActive'],
	data() {
		return {
			isLanguageSelect: false,
			socialList:[],
			boardList: [],
			search: '',
			socialLearningBoardSocial:'',
			activeRouteNameSocial:'',
			routeName: [],
		}
	},

	computed: {
		...mapState([
			'languageMode'
		])
	},
	watch:{
		$route(to,from){
			let routeNameSocial = this.$route.path.split('/');
			let pathNameSocial = routeNameSocial[1];
			if(this.$route.name.toLowerCase()=='sociallearning'){
				this.socialLearningBoardSocial = this.$route.params.board
				this.activeRouteNameSocial = this.$route.params.board
			}
		}
	},

	mounted() {
		let params = {
			brandCode: localStorage.getItem('brandCode')
		}
		this.routeQuery = this.$route.query;
		if (localStorage.getItem('brandCode')) {
			// 브랜드 언어 목록 가져오기(get service language list)
			i18nApi.guestLanguagePack(params).then((response) => {
				this.languageList = response.data.data
			})
		}


		boardApi.navigationList().then((response) => {
			// console.log('response=>',response.data.data)
			this.boardList = response.data.data.filter(e =>e.boardAuth==true);
		})
		let routeNameSocial = this.$route.path.split('/');
		this.routeName = this.$route.path.split("/").slice(1);
	//	console.log(routeNameSocial)
		//this.routeName = this.$route.path.split("/").slice(1);
			let pathNameSocial = routeNameSocial[1];
			if(this.$route.name.toLowerCase()==pathNameSocial) {
				if(this.$route.name.toLowerCase()=='sociallearning'){
					this.socialLearningBoardSocial = this.$route.params.board
					this.activeRouteNameSocial = this.$route.params.board
				}else {
					this.activeRouteNameSocial = this.$route.name.toLowerCase()
				}
				} else {
			//this.activeRouteName = 'main'
			}
	},

	filters: {
		charLimit: function(str) {
				let length = 17;
				let ending = ' ...';
				let str1='';
				if(str.length>length){
					str1 = str.substr(0, length) + ending;
					return str1;
				} else {
					return str;
				}
			}
	},

	methods: {
		...mapMutations(['SET_LANGUAGE_MODE']),
		splitValue(boardNameData){
			if(boardNameData){
			return boardNameData.split("+").join(" ");
			}
			return 0;
		},
		autoCloseToggleBoard(evt) {
		var boardarray = document.getElementsByClassName("navDrawerSubmenu");
		let closeSubmenuBoard = evt.target.parentNode.nextElementSibling.className.split(/\s+/).find(val=>val=='d-none');
			for(var i = 0; i < boardarray.length; i++){
				boardarray[i].className += " d-none";
				boardarray[i].previousSibling.lastElementChild.innerHTML = 'keyboard_arrow_down'
			}
			if(closeSubmenuBoard) {
				evt.target.parentNode.nextElementSibling.classList.toggle("d-none")
				evt.target.innerHTML = 'keyboard_arrow_up'
			}
		},

		// 언어 목록 토글(toggle language list)
		toggleLanguageSelect() {
			this.isLanguageSelect = !this.isLanguageSelect
		},
		// 언어 변경(change language)
		changeLanguage(lang){
			setUserLanguage(lang.code).then(() => {
				this.$emit('closeDrawer')
			})
		},
		// closeDrawer() {
		//     this.$emit("closeDrawer");
		// },
		closeDrawer() {
			this.isDrawerOpen = false;
		},
		searchLang() {

			return this.languageList.filter((lang) => {
				return lang.code.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
			})
		},
		getBoard(board){
			localStorage.setItem('boardName',board.name)
			//this.$router.push('/board/'+board.identifier+'?boardName='+encodeURI(board.name)+'&categoryName='+encodeURI(board.boardCategory.name))
			//console.log('board',board)
		}
	}
}
</script>
<style scoped>

</style>
